export default {
    app: [
        { required: true, message: 'App值不能为空' },
        { type: 'number', message: 'App值必须为0 ~ 255的数字' }
    ],
    group: [
        { required: true, message: 'Group值不能为空' },
        { type: 'number', message: 'Group值必须为0 ~ 255的数字' }
    ],
    level: [
        { type: 'number', message: 'Level值必须为0 ~ 255的数字' }
    ]
}


// WEBPACK FOOTER //
// ./src/api/rule.js